<template>
  <teleport to="body" v-if="showPosReturnReceipt">
    <div id="pos-return-print-area-portal">
      <PosReturnReceiptPrint
        :company="company"
        :saleReturn="salesReturn"
        :customizationPdfFields="customizationPdfFields"
        :posPrintSize="posPrintSize"
      />
    </div>
  </teleport>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import handlePurchaseAndSalesReturn from '@/services/modules/purchaseSalesReturn'
import handleCompany from '@/services/modules/company'
import salesReturnHelper from '@/services/utils/pdf/salesReturnHelper'
import PosReturnReceiptPrint from '@/components/molecule/company/pos-invoice/PosReturnReceiptPrint.vue'

const props = defineProps({
  company: {
    type: Object,
    default: () => ({})
  },
  billType: {
    type: String,
    default: 'electronic_invoice'
  }
})

const emit = defineEmits(['done'])

const $route = useRoute()
const { fetchSalesReturn } = handlePurchaseAndSalesReturn()
const { fetchActiveCustomizationField, getCompanyPreferences } = handleCompany()
const { generatePdf } = salesReturnHelper()

const customizationPdfFields = ref({})
const posPrintSize = ref(58)
const showPosReturnReceipt = ref(false)
const salesReturn = ref({})

const empty = (value) => {
  if (value === null || value === undefined || value === '' || value === false || value === 0) return true
  if (Array.isArray(value)) return value.length === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return false
}

const getActiveFieldCustomization = () => {
  const companyQuery = `?company_id=${$route.params.companyId}&customization_type=pdf&type=sale_return_pdf`
  return fetchActiveCustomizationField(companyQuery).then((res) => {
    customizationPdfFields.value = res.data
  })
}

const getPosPrintSizeData = () => {
  const queryObject = {
    company_id: $route.params.companyId,
    fields: 'pos_print_size'
  }
  const query = '?' + new URLSearchParams(queryObject).toString()
  return getCompanyPreferences(query).then((res) => {
    if (! res.status) return
    const item = res.data.find((field) => field.field === 'pos_print_size')
    if (empty(item)) return
    posPrintSize.value = item.value
  })
}

const onAfterPrint = () => {
  showPosReturnReceipt.value = false
  window.removeEventListener('afterprint', onAfterPrint)
  emit('done')
}

const printPosReturnReceipt = async () => {
  showPosReturnReceipt.value = true
  await nextTick()
  window.addEventListener('afterprint', onAfterPrint)
  window.print()
}

const settingsLoaded = Promise.all([
  getActiveFieldCustomization(),
  getPosPrintSizeData()
])

const triggerPrint = (returnId) => {
  const query = `?company_id=${$route.params.companyId}`

  Promise.all([settingsLoaded, fetchSalesReturn(returnId, query)]).then((results) => {
    const res = results[1]
    salesReturn.value = res.data

    if (empty(customizationPdfFields.value.heading_left_pos_print)) {
      generatePdf(props.company, salesReturn.value, props.billType)
      emit('done')
      return
    }

    printPosReturnReceipt()
  })
}

defineExpose({
  triggerPrint
})
</script>
